import Navbar from "./Navbar";
import Hero from "./Hero";
import SocialProof from "./SocialProof";
import Services from "./Services";
import Pricing from "./Pricing";
import Process from "./Process";
import Cases from "./Cases";
import WhyUs from "./WhyUs";
import ContactForm from "./ContactForm";
import Footer from "./Footer";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#050505] text-white overflow-x-hidden">
      <Navbar />
      <Hero />
      <SocialProof />
      <Services />
      <Cases />
      <Pricing />
      <Process />
      <WhyUs />
      <ContactForm />
      <Footer />
    </div>
  );
}
